import React from 'react'

import { Routes, Route } from 'react-router-dom'

import Home from './page/Safra/Home'

import HotelsSearchResult from "./page/Safra/HotelsSearchResult";
import HotelsFilter from "./page/Safra/HotelsFilter";
import HotelPage from './page/Safra/HotelPage'
import HotelResume from "./page/Safra/HotelResume";

import CarSearchResult from './page/CarSearchResult'
import CarResume from './page/CarResume'
import PassageSearchResult from "./page/Safra/PassageSearchResult";
import PassageFilter from "./page/Safra/PassageFilter";
import PassageResume from "./page/Safra/PassageResume";
import PassengerDataPage from "./page/Safra/PassengerDataPage";

import Checkout from './page/Safra/Checkout'
import CheckoutMessage from "./page/Safra/CheckoutMessage";

import { Error404 } from "./page/Error";

import { TranslationProvider } from './contexts/Safra/TranslationContext'

export default function ConnectionBetweenPages() {
  return (
    <TranslationProvider>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="hotels-search-result" element={<HotelsSearchResult />} />
        <Route path="hotels-filter" element={<HotelsFilter />} />
        <Route path="hotel-page" element={<HotelPage />} />
        <Route path="hotel-resume" element={<HotelResume />} />

        <Route path="cars-search-result" element={<CarSearchResult />} />
        <Route path="car-resume" element={<CarResume />} />

        <Route path="passage-search-result" element={<PassageSearchResult />} />
        <Route path="passage-filter" element={<PassageFilter />} />
        <Route path="passage-resume" element={<PassageResume />} />
        <Route path="passage-passenger-data" element={<PassengerDataPage />} />

        <Route path="checkout/:product" element={<Checkout />} />

        <Route path="success-checkout/:id" element={<CheckoutMessage />} />
        <Route path="error-checkout" element={<CheckoutMessage />} />

        <Route path="*" element={<Error404 />} />
      </Routes>
    </TranslationProvider>
  )
}
